import style from './progressArrow.module.css';

import classNames from 'classnames';

/**
 * Компонент `ProgressArrow` отображает горизонтальную стрелку, которая может менять цвет
 * в зависимости от переданного варианта (статуса).
 *
 * @component
 * @example
 * // Основной вариант (по умолчанию)
 * <ProgressArrow />
 *
 * @example
 * // Акцентный вариант
 * <ProgressArrow variant="accent" />
 *
 * @example
 * // Ошибочный вариант
 * <ProgressArrow variant="error" />
 *
 * @param {Object} props - Свойства компонента.
 * @param {'primary' | 'accent' | 'error'} [props.variant='primary'] - Вариант отображения стрелки.
 *
 * @returns {JSX.Element} JSX-элемент стрелки.
 */
const ProgressArrow = ({ variant = 'primary' }) => {
  return (
    <div className={style.container}>
      <div
        className={classNames(style.line, {
          [style.primary]: variant === 'primary',
          [style.accent]: variant === 'accent',
          [style.error]: variant === 'error',
        })}
      >
        <div className={style.start} />
        <div
          className={classNames(style.end, {
            [style.primary]: variant === 'primary',
            [style.accent]: variant === 'accent',
            [style.error]: variant === 'error',
          })}
        />
      </div>
    </div>
  );
};

export default ProgressArrow;
